'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  DELIVERY_FAILED: null,
  DELIVERY_PENDING_AND_POLLING_STATUS: null,
  DELIVERY_PENDING_AND_NOT_POLLING_STATUS: null,
  DELIVERY_SUCCEEDED_BEFORE_LAST_PAGE_LOAD: null,
  DELIVERY_SUCCEEDED_CONFIRMED_BY_POLLING: null,
  UNINSTALLED: null,
  REFUNDED: null
});